export const supervisionMessages = {
  fr: {
    supervision: {
      alertTitle: "Information supervision",
      alertText: "Cette section présente l'historique des supervisions de cette mission.",
      errorTitle: "Erreur de chargement",
      type: "Type",
      startedAt: "Date de début",
      endedAt: "Date de fin",
      reviewer: "Relecteur",
      decisionStatus: "Statut",
      startButtonSelfControl: "Démarrer/reprendre l'auto-contrôle",
      startButtonReview: "Démarrer/reprendre la relecture",
      startButtonSupervision: "Démarrer/reprendre la supervision",
      confirmAlertTitle: "La mission va être inaccessible",
      confirmText:
        "La mission va être inaccessible. Attention, vous allez démarrer une relecture. Cette action bloque l'accès de la mission aux autres utilisateurs jusqu'à la fin de votre relecture. Voulez-vous continuer ?",
      notAccessibleTitle: "Relecture en cours",
      notAccessibleAlertTitle: "Mission non accessible",
      notAccessibleText:
        "La mission que vous essayez de consulter est en cours de relecture et ne doit pas être modifiée pour le moment.",
      startSuccessMessage: "La supervision a été démarrée avec succès.",

      types: {
        AUTO_CONTROL: "Auto-contrôle",
        REVIEW: "Relecture",
        SUPERVISION: "Supervision",
      },
      shared: {
        cancel: "Annuler",
        forceEndSupervision: "Forcer fin relecture",
        start: "Démarrer",
        errorOccurred: "Une erreur est survenue lors du démarrage de la supervision.",
      },
      statuses: {
        BON_POUR_ENVOI: "Bon pour envoi",
        BON_POUR_ENVOI_APRES_CORRECTION: "Bon pour envoi après correction",
        NOUVELLE_SUPERVISION_APRES_CORRECTION: "Nouvelle supervision après correction",
        FIN_FORCEE: "Fin forcée",
        A_ENVOYER_POUR_RELECTURE: "À envoyer pour relecture",
        BON_POUR_ENVOI_EN_SUPERVISION: "Bon pour envoi en supervision",
        BON_POUR_ENVOI_EN_SUPERVISION_APRES_CORRECTION:
          "Bon pour envoi en supervision après correction",
        NOUVELLE_RELECTURE_APRES_CORRECTION: "Nouvelle relecture après correction",
      },
    },
  },
  en: {
    supervision: {
      alertTitle: "Supervision information",
      alertText: "This section shows the supervision history for this mission.",
      errorTitle: "Loading error",
      type: "Type",
      startedAt: "Start date",
      endedAt: "End date",
      reviewer: "Reviewer",
      decisionStatus: "Status",
      startButtonSelfControl: "Start/edit self-control",
      startButtonReview: "Start/edit review",
      startButtonSupervision: "Start/edit supervision",
      confirmAlertTitle: "The mission will be inaccessible",
      confirmText:
        "The mission will be inaccessible. Warning, you are about to start a review. This action blocks access to the mission for other users until the end of your review. Do you want to continue?",
      notAccessibleTitle: "Review in progress",
      notAccessibleAlertTitle: "Mission not accessible",
      notAccessibleText:
        "The mission you are trying to access is currently under review and should not be modified at this time.",
      startSuccessMessage: "Supervision started successfully.",
      types: {
        AUTO_CONTROL: "Self-control",
        REVIEW: "Review",
        SUPERVISION: "Supervision",
      },
      shared: {
        cancel: "Cancel",
        start: "Start",
        forceEndSupervision: "Force end review",
        errorOccurred: "An error occurred while starting the supervision.",
      },
      statuses: {
        BON_POUR_ENVOI: "Approved for submission",
        BON_POUR_ENVOI_APRES_CORRECTION: "Approved for submission after correction",
        NOUVELLE_SUPERVISION_APRES_CORRECTION: "New supervision after correction",
        FIN_FORCEE: "Forced end",
        BON_POUR_ENVOI_EN_SUPERVISION: "Approved for supervision",
        BON_POUR_ENVOI_EN_SUPERVISION_APRES_CORRECTION: "Approved for supervision after correction",
        NOUVELLE_RELECTURE_APRES_CORRECTION: "New review after correction",
      },
    },
  },
};
